var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { IconBaseSvg } from "../icon-base";
var FavoriteIcon = function (props) { return (React.createElement(IconBaseSvg, __assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("path", { d: "M12,21.35l-1.45-1.32C5.4,15.36,2,12.28,2,8.5A5.447,5.447,0,0,1,7.5,3,5.988,5.988,0,0,1,12,5.09,5.988,5.988,0,0,1,16.5,3,5.447,5.447,0,0,1,22,8.5c0,3.78-3.4,6.86-8.55,11.54Z" }))); };
export default FavoriteIcon;
//# sourceMappingURL=FavoriteIcon.js.map